<template>
    <div class="block mb-4 bg-white text-zinc-900 dark:bg-black dark:text-zinc-100 pt-1">
    <div class="block mb-4 bg-white text-zinc-900 dark:bg-black dark:text-zinc-100 pt-1 flex flex-wrap gap-2">
        <Dropdown v-model="selectedYear" :options="yearlist" filter optionLabel="name" placeholder="Selecciona el Año" class="w-45" @change="getYear(selectedYear)">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ slotProps.value.id }}</div>
                </div>
                <span v-else>
                    {{ slotProps.placeholder }}
                </span>
            </template>
            <template #option="slotProps">
                <div class="flex align-items-center">
                    <div>{{ slotProps.option.id }}</div>
                </div>
            </template>
        </Dropdown>
        <Dropdown v-model="selectedCompany" :options="companies" optionLabel="name" placeholder="Selecciona empresa" class="w-45" @change="companyChange" />
        <Dropdown v-model="selectedBranch" :options="selectedCompany.branches || []" optionLabel="name" placeholder="Selecciona sucursal" class="w-45" @change="getYearToDay(selectedYear.id)" filter />
        <Dropdown v-model="selectedTax" :options="tax_select" optionLabel="name" placeholder="Selecciona impuesto" class="w-45" @change="changeIva" />
    </div>
    </div>
                        
    <div class="h-full w-full pr-3 pl-3 bg-white text-zinc-900 dark:bg-black dark:text-zinc-100">
        <div class="card">
                <p class="capitalize text-2xl font-semibold text-justify mt-6 mb-2 dark:text-zinc-100">Totales Generales</p>
                <Chart type="bar" :data="chartData" :options="chartOptions" class="h-30rem" />
        </div>
        <div class="card">
                <p class="capitalize text-2xl font-semibold text-justify mt-6 mb-2 dark:text-zinc-100">Gastos Anuales</p>
                <Chart type="bar" :data="chartData_gastos_anuales" :options="chartOptions_gastos_anuales" class="h-30rem" />
        </div>
        <div class="card">
                <p class="capitalize text-2xl font-semibold text-justify mt-6 mb-2 dark:text-zinc-100">Utilidad Anual</p>
                <Chart type="line" :data="chartData_utilidad" :options="chartOptions_utilidad" class="h-30rem" />
        </div>
        <DataTable :value="t_facturado" ref="dt" tableStyle="min-width: 20rem" class="dTable_ytd bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
            <Column field="13" header="YearToDay" exportHeader="Product Code" class="title_col"></Column>
            <Column field="12" header="Total"></Column>
            <Column field="0" header="Ene"></Column>
            <Column field="1" header="Feb"></Column>
            <Column field="2" header="Mar"></Column>
            <Column field="3" header="Abr"></Column>
            <Column field="4" header="May"></Column>
            <Column field="5" header="Jun"></Column>
            <Column field="6" header="Jul"></Column>
            <Column field="7" header="Ago"></Column>
            <Column field="8" header="Sep"></Column>
            <Column field="9" header="Oct"></Column>
            <Column field="10" header="Nov"></Column>
            <Column field="11" header="Dic"></Column>
        </DataTable>
        <p class="capitalize text-2xl font-semibold text-justify text-zinc-900 dark:text-zinc-100 mt-6 mb-2">Edo. Resultados Mensual</p>
        <div class="card py-2">
        <TabView>
                <TabPanel header="Enero">
                        <div class="flex ">
                        <div class="grid w-3/5">
                                <DataTable :value="t_Resultados_enero" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                        <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                        <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                        <Column field="meta" header="Meta"></Column>
                                        <Column field="eficiencia" header="Eficiencia"></Column>
                                        <Column field="byReal" header="Año Anterior"></Column>
                                        <Column field="byEficiencia" header="Eficiencia"></Column>
                                </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_enero" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Febrero">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_febrero" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_febrero" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Marzo">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_marzo" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_marzo" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Abril">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_abril" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_abril" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Mayo">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_mayo" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_mayo" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Junio">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_junio" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_junio" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Julio">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_julio" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_julio" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Agosto">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_agosto" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_agosto" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Septiembre">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_septiembre" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_septiembre" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Octubre">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_octubre" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_octubre" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Noviembre">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_noviembre" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_noviembre" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
                <TabPanel header="Diciembre">
                        <div class="flex ">
                        <div class="grid w-3/5">
                        <DataTable :value="t_Resultados_diciembre" ref="dt" tableStyle="min-width: 20rem" class="dTable_edr bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded">
                                <Column field="13" header="Edo. Resultados" exportHeader="Product Code" class="title_col"></Column>
                                <Column field="real" header="Real" exportHeader="Product Code"></Column>
                                <Column field="meta" header="Meta"></Column>
                                <Column field="eficiencia" header="Eficiencia"></Column>
                                <Column field="byReal" header="Año Anterior"></Column>
                                <Column field="byEficiencia" header="Eficiencia"></Column>
                        </DataTable>
                        </div>
                        <div class="grid inline-block align-middle w-2/5 flex items-center justify-center">
                                <Chart type="doughnut" :data="t_Gastos_diciembre" :options="chartOptions_gastosXmes" class="donut_chart_g w-full md:w-50rem" />
                        </div>
                        </div>
                </TabPanel>
            
        </TabView>
    </div>
    </div>
</template>

<script> 
//import axios from 'axios';
import axiosInstance from '../axiosInstance';

export default {
data() {
        return {
                selectedTax: 1.16,
                tax_select: [
                        { name: 'Con Iva (16%)', code: 1.16 },
                        { name: 'Sin Iva (-16%)', code: 1 },
                ],
                t_facturado: [{}],
                t_Resultados_enero: [{}],
                t_Resultados_febrero: [{}],
                t_Resultados_marzo: [{}],
                t_Resultados_abril: [{}],
                t_Resultados_mayo: [{}],
                t_Resultados_junio: [{}],
                t_Resultados_julio: [{}],
                t_Resultados_agosto: [{}],
                t_Resultados_septiembre: [{}],
                t_Resultados_octubre: [{}],
                t_Resultados_noviembre: [{}],
                t_Resultados_diciembre: [{}],

                sdata_cIvaFacturado: [{}], // almacen de datos de la tabla YTD con iva
                sdata_sIvaFacturado: [{}], // almacen de datos de la tabla YTD sin iva
                sdata_cIvaResultadosMes: [{}], // almacen de datos por mes con iva - guarda los 12 meses del año
                sdata_sIvaResultadosMes: [{}], // almacen de datos por mes sin iva - guarda los 12 meses del año

                chartOptions_gastosXmes: {
                        cutout: '60%',
                        plugins: {
                                legend: {
                                        labels: {
                                                font: {
                                                        family: 'Poppins, Roboto, sans-serif'
                                                }
                                        }
                                }
                        }
                },
                t_Gastos_enero: null,
                t_Gastos_febrero: null,
                t_Gastos_marzo: null,
                t_Gastos_abril: null,
                t_Gastos_mayo: null,
                t_Gastos_junio: null,
                t_Gastos_julio: null,
                t_Gastos_agosto: null,
                t_Gastos_septiembre: null,
                t_Gastos_octubre: null,
                t_Gastos_noviembre: null,
                t_Gastos_diciembre: null,
                chartData: null,
                chartOptions: null,
                chartData_gastos_anuales: null,
                chartOptions_gastos_anuales: null,
                chartData_utilidad: null,
                chartOptions_utilidad: null,

                selectedCompany: {},
                companies: [],
                selectedBranch: {},
                selectedYear: null,
                yearlist: [{id: new Date().getFullYear()}],
                metaUtilidadReal : {
                2017: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2018: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2019: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2020: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2021: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2022: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2023: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000], 
                2024: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2025: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
                2026: [400000, 415000, 430000, 445000, 460000, 475000, 485000, 500000, 500000, 500000, 500000, 500000],
            },
                valorCrecimiento : {
                2017: 1.16,
                2018: 1.16,
                2019: 1.16,
                2020: 1.16,
                2021: 1.18,
                2022: 1.20,
                2023: 1.22,
                2024: 1.24,
                2025: 1.26,
                2026: 1.28,
            },
        }
    },
    methods: {
        exportCSV() {
            this.$refs.dt.exportCSV();
        },
        changeIva() {
                // year es igual a this.selectedYear.id y si es valor nulo debe ser el año acutal
                var year =   new Date().getFullYear();
                var lastYear = year - 1;
                var t_Resultados = []
                console.log("Valor seleccionado selectedTax:", this.selectedTax);
                //AQUI ME QUEDE--------------------------------------------------
                if (this.selectedTax.code == 1) {
                                console.log("___Sin Iva valor");
                                this.t_facturado = this.sdata_sIvaFacturado;
                                this.setChartGeneralData(this.sdata_sIvaFacturado, this.sdata_sIvaLYFacturado, year, lastYear); 
                                t_Resultados = this.sdata_sIvaResultadosMes;
                }else{
                        if (this.selectedTax.code == 1.16) {
                                console.log("___Con Iva 16%"); 
                                this.t_facturado = this.sdata_cIvaFacturado;
                                this.setChartGeneralData(this.sdata_cIvaFacturado, this.sdata_cIvaLYFacturado, year, lastYear);
                                t_Resultados = this.sdata_cIvaResultadosMes;
                                
                        }else{
                                console.log("___Otro valor");
                        }
                }


                        for (let inx = 0; inx < 12; inx++) {
                                var   t_Resultados_mes = t_Resultados[inx]; 

                                var t_Resultados_gastos_pie = [];
                                        t_Resultados_gastos_pie['administracion'] = t_Resultados_mes[10]['real'];
                                        t_Resultados_gastos_pie['comercial'] = t_Resultados_mes[11]['real'];
                                        t_Resultados_gastos_pie['operaciones'] = t_Resultados_mes[12]['real'];
                                        t_Resultados_gastos_pie['extraordinario'] = t_Resultados_mes[13]['real'];
                        
                                switch (inx) {
                                        case 0:
                                                this.t_Resultados_enero = t_Resultados_mes;
                                                this.t_Gastos_enero = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 1:
                                                this.t_Resultados_febrero = t_Resultados_mes;
                                                this.t_Gastos_febrero = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 2:
                                                this.t_Resultados_marzo = t_Resultados_mes;
                                                this.t_Gastos_marzo = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 3:
                                                this.t_Resultados_abril = t_Resultados_mes;
                                                this.t_Gastos_abril = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 4:
                                                this.t_Resultados_mayo = t_Resultados_mes;
                                                this.t_Gastos_mayo = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 5:
                                                this.t_Resultados_junio = t_Resultados_mes;
                                                this.t_Gastos_junio = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 6:
                                                this.t_Resultados_julio = t_Resultados_mes;
                                                this.t_Gastos_julio = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 7:
                                                this.t_Resultados_agosto = t_Resultados_mes;
                                                this.t_Gastos_agosto = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 8:
                                                this.t_Resultados_septiembre = t_Resultados_mes;
                                                this.t_Gastos_septiembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 9:
                                                this.t_Resultados_octubre = t_Resultados_mes;
                                                this.t_Gastos_octubre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 10:
                                                this.t_Resultados_noviembre = t_Resultados_mes;
                                                this.t_Gastos_noviembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 11:
                                                this.t_Resultados_diciembre = t_Resultados_mes;
                                                this.t_Gastos_diciembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                }
                        }

        },
        setChartDataT_gastos_mes(data_items) {
            const documentStyle = getComputedStyle(document.body);
            var admin = typeof data_items['administracion'] === 'string' ? data_items['administracion'].replace(/,/g, "") : data_items['administracion'];
            var come = typeof data_items['comercial'] === 'string' ? data_items['comercial'].replace(/,/g, "") : data_items['comercial'];
            var oper = typeof data_items['operaciones'] === 'string' ? data_items['operaciones'].replace(/,/g, "") : data_items['operaciones'];
            var extr = typeof data_items['extraordinario'] === 'string' ? data_items['extraordinario'].replace(/,/g, "") : data_items['extraordinario'];

            return {
                labels: [       
                        'Administracion - ' + admin, 
                        'Comercial - ' + come, 
                        'Operaciones - ' + oper, 
                        'Extraordinario - ' + extr
                ],
                datasets: [
                    {
                        data: [
                                admin,
                                come,
                                oper,
                                extr
                        ],
                        backgroundColor: [
                                documentStyle.getPropertyValue('--blue-500'), 
                                documentStyle.getPropertyValue('--green-500'), 
                                documentStyle.getPropertyValue('--yellow-500'), 
                                documentStyle.getPropertyValue('--orange-500')
                        ],
                        hoverBackgroundColor: [
                                documentStyle.getPropertyValue('--blue-400'), 
                                documentStyle.getPropertyValue('--green-400'), 
                                documentStyle.getPropertyValue('--yellow-400'), 
                                documentStyle.getPropertyValue('--orange-400')
                        ],
                        options: {
                        }
                    }
                ]
            };
        },
        setChartData_utilidad(data_items, lastYear, year) {
            const documentStyle = getComputedStyle(document.documentElement);
                console.log(year);
            return {
                labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                datasets: [
                    {
                        label: 'Utilidad Real',
                        data: data_items[0],
                        fill: false,
                        tension: 0.4,
                        borderColor: documentStyle.getPropertyValue('--green-500')
                    },
                    {
                        label: 'Utilidad Meta',
                        data: data_items[1],
                        fill: false,
                        borderColor: documentStyle.getPropertyValue('--blue-500'),
                        tension: 0.4
                    },
                    {
                        label: 'Utilidad Faltante',
                        data: data_items[2],
                        fill: false,
                        borderColor: documentStyle.getPropertyValue('--orange-500'),
                        tension: 0.4
                    },
                    {
                        label: 'Utilidad '+lastYear,
                        data: data_items[3],
                        fill: true,
                        borderColor: documentStyle.getPropertyValue('--yellow-500'),
                        tension: 0.4,
                        backgroundColor: 'rgba(255,167,38,0.2)'
                    }
                ]
            };
        },
        setChartOptions_utilidad() {
            const documentStyle = getComputedStyle(document.documentElement);
            const isDark = document.documentElement.classList.contains('dark');
            const textColor = isDark ? documentStyle.getPropertyValue('--text-color') || '#f4f4f5' : '#18181b';
            const textColorSecondary = isDark ? documentStyle.getPropertyValue('--text-color-secondary') || '#d1d5db' : '#52525b';
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                        tooltip: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                title: function (tooltipItems) {
                                        // We'll use the first tooltipItem to get the x-axis label (month)
                                        const monthLabel = tooltipItems[0].label;
                                        return monthLabel;
                                },
                                label: function (tooltipItem) {
                                        // Custom label callback to display all section information
                                        const datasetLabel = tooltipItem.dataset.label;
                                        const value = tooltipItem.formattedValue;
                                        return `${datasetLabel}: ${value}`;
                                }
                                }
                        },
                        legend: {
                                labels: {
                                color: textColor,
                                font: {
                                    family: 'Poppins, Roboto, sans-serif'
                                }
                                }
                        }
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },     
        setChartData_gastos_anuales(data_items, data_items_ly, lastYear, year) {
            const documentStyle = getComputedStyle(document.documentElement);
            // crear un array de totales donde se sumen todos los valores de data_items por mes
                let totales = [];
                let totales_ly = [];
                for (let i = 0; i < data_items[0].length; i++) {
                    //totales.push(data_items[0][i] + data_items[1][i] + data_items[2][i] + data_items[3][i]);
                    // SUMAR LOS VGALORES DE CADA MES POR CADA DEPARTAMENTO VALIDANDO QUE EL DATO SEA STRING
                        let total = 0;
                        let total_ly = 0;
                        for (let j = 0; j < data_items.length; j++) {
                            if (typeof data_items[j][i] === 'string') {
                                total += parseFloat(data_items[j][i]);
                                total_ly += parseFloat(data_items_ly[j][i]);
                            }
                        }
                        totales.push(total);
                        totales_ly.push(total_ly);
                }
                console.log("totales=======================");
                console.log(totales);
            return {
                labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                datasets: [
                    {
                        type: 'bar',
                        label: 'Administración',
                        backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                        data: data_items[0]
                    },
                    {
                        type: 'bar',
                        label: 'Comercial',
                        backgroundColor: documentStyle.getPropertyValue('--green-500'),
                        data: data_items[1]
                    },
                    {
                        type: 'bar',
                        label: 'Operaciones',
                        backgroundColor: documentStyle.getPropertyValue('--yellow-500'),
                        data: data_items[2]
                    },
                    {
                        type: 'bar',
                        label: 'Extraordinario',
                        backgroundColor: documentStyle.getPropertyValue('--red-500'),
                        data: data_items[3]
                    },
                    {
                        type: 'line',
                        label: 'Total '+year,
                        borderColor: documentStyle.getPropertyValue('--blue-500'),
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        data: totales
                    },
                    {
                        type: 'line',
                        label: 'Total '+lastYear,
                        borderColor: documentStyle.getPropertyValue('--red-500'),
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        data: totales_ly
                    },
                ]
            };
        },
        setChartOptions_gastos_anuales() {
            const documentStyle = getComputedStyle(document.documentElement);
            const isDark = document.documentElement.classList.contains('dark');
            const textColor = isDark ? documentStyle.getPropertyValue('--text-color') || '#f4f4f5' : '#18181b';
            const textColorSecondary = isDark ? documentStyle.getPropertyValue('--text-color-secondary') || '#d1d5db' : '#52525b';
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                        tooltip: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                title: function (tooltipItems) {
                                        // We'll use the first tooltipItem to get the x-axis label (month)
                                        const monthLabel = tooltipItems[0].label;
                                        return monthLabel;
                                },
                                label: function (tooltipItem) {
                                        // Custom label callback to display all section information
                                        const datasetLabel = tooltipItem.dataset.label;
                                        const value = tooltipItem.formattedValue;
                                        return `${datasetLabel}: ${value}`;
                                }
                                }
                        },
                        legend: {
                                labels: {
                                color: textColor,
                                font: {
                                    family: 'Poppins, Roboto, sans-serif'
                                }
                                }
                        }
                },
                scales: {
                    x: {
                        stacked: true,
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },
        setChartData(data_items) {
            const documentStyle = getComputedStyle(document.documentElement);

            return {
                labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                datasets: [
                    {
                        type: 'bar',
                        label: 'FACTURACION',
                        borderColor: documentStyle.getPropertyValue('--blue-500'),
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        data: data_items[0]
                    },
                    {
                        type: 'bar',
                        label: 'COBRANZA',
                        backgroundColor: documentStyle.getPropertyValue('--green-500'),
                        data: data_items[1],
                        borderColor: 'white',
                        borderWidth: 2
                    },
                    {
                        type: 'bar',
                        label: 'GASTOS',
                        backgroundColor: documentStyle.getPropertyValue('--orange-500'),
                        data: data_items[2]
                    }
                ]
            };
        },
        setChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const isDark = document.documentElement.classList.contains('dark');
            const textColor = isDark ? documentStyle.getPropertyValue('--text-color') || '#f4f4f5' : '#18181b';
            const textColorSecondary = isDark ? documentStyle.getPropertyValue('--text-color-secondary') || '#d1d5db' : '#52525b';
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                        tooltip: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                title: function (tooltipItems) {
                                        const monthLabel = tooltipItems[0].label;
                                        return monthLabel;
                                },
                                label: function (tooltipItem) {
                                        const datasetLabel = tooltipItem.dataset.label;
                                        const value = tooltipItem.formattedValue;
                                        return `${datasetLabel}: ${value}`;
                                }
                                }
                        },
                    legend: {
                        labels: {
                            color: textColor,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                family: 'Poppins, Roboto, sans-serif'
                            }
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },
        getNumberNoFormat(numero) {
                numero = typeof numero === 'string' ? numero.replace(/,/g, "") : numero;
                return numero;
        },
        getNumberFormat(texto) {
                if (texto == null) return '0.00';
                texto = typeof texto === 'string' ? texto : (texto.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return texto;
        },
        getMeta(ValorCecimiento, valorAnioAnterior) {
                const factor = Array.isArray(ValorCecimiento) ? ValorCecimiento[0] : ValorCecimiento;
                if (factor == null || isNaN(factor)) return 'N/A';
                valorAnioAnterior = typeof valorAnioAnterior === 'string' ? valorAnioAnterior.replace(/,/g, "") : valorAnioAnterior;
                const num = parseFloat(valorAnioAnterior);
                if (isNaN(num)) return 'N/A';
                var meta = factor * num;
                if (isNaN(meta)) return 'N/A';
                meta = (meta.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return meta;
        },
        getEficiencia(valor1, valor2) {
                valor1 = typeof valor1 === 'string' ? valor1.replace(/,/g, "") : valor1;
                valor2 = typeof valor2 === 'string' ? valor2.replace(/,/g, "") : valor2;
                if (!valor2 || isNaN(valor2) || parseFloat(valor2) === 0) return 'N/A';
                var eficiencia = valor1/valor2;
                if (!isFinite(eficiencia) || isNaN(eficiencia)) return 'N/A';
                return eficiencia.toFixed(2);
        },
        getDaysInMonth(month, year) {
                const date = new Date(year, month, 1);
                date.setMonth(date.getMonth() + 1);
                date.setDate(date.getDate() - 1);
                return date.getDate();
        },
        companyChange() {
            this.selectedBranch = this.selectedCompany.branches[0];
            this.getYearToDay(this.selectedYear.id);
        },
        async fetchInitialData() {
            try {
                const response = await axiosInstance.post("/api/client_finances", {
                    token: localStorage.getItem('token')
                });
                const data = response.data;
                const defaultCmp = data.defaultCmp;
                this.selectedCompany = {
                    name: defaultCmp.data.name,
                    id: defaultCmp.data.id,
                    branches: defaultCmp.branches
                };
                this.companies = data.companies.map(function(company) {
                    return {
                        name: company.data.name,
                        id: company.data.id,
                        branches: company.branches
                    };
                });
                this.selectedBranch = this.selectedCompany.branches[0];
                return true;
            } catch(error) {
                console.error("fetchInitialData error:", error);
                return false;
            }
        },
        getYear(year) {
        console.log("Selected year:", year);
        this.getYearToDay(year.id);
        },
        async getYearToDay(year) {
            this.$emit('update-loading', true);
            var lastYear = year - 1;
            

            try {
                //Año actual   ==============================
                const responseFacturado = axiosInstance.post("/api/client_finances_data", {
                        token: localStorage.getItem('token'), 
                        year: year,
                        report: 2,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });
                const responseCobrado = axiosInstance.post("/api/client_finances_data", {
                        token: localStorage.getItem('token'), 
                        year: year,
                        report: 1,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });
                
                const resAnalisisGastos = axiosInstance.post("/api/fullyear_expenses_viewer_data", {
                        token: localStorage.getItem('token'), 
                        year: year,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });

                const resSpots = axiosInstance.post("/api/fullyear_clients_report_data", {
                        token: localStorage.getItem('token'),
                        order_by: 'name',
                        year: year
                });
                //Año actual   ==============================


                //Año anterior ==============================
                const LYresponseFacturado = axiosInstance.post("/api/client_finances_data", {
                        token: localStorage.getItem('token'), 
                        year: lastYear,
                        report: 2,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });
                const LYresponseCobrado = axiosInstance.post("/api/client_finances_data", {
                        token: localStorage.getItem('token'), 
                        year: lastYear,
                        report: 1,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });
                
                const LYresAnalisisGastos = axiosInstance.post("/api/fullyear_expenses_viewer_data", {
                        token: localStorage.getItem('token'), 
                        year: lastYear,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                });

                const LYresSpots = axiosInstance.post("/api/fullyear_clients_report_data", {
                        token: localStorage.getItem('token'),
                        order_by: 'name',
                        year: lastYear
                });
                //Año anterior ==============================


                const [ caFacturado, 
                        caCobrado,
                        analisisGastos_d,
                        spots_d,
                        LYcaFacturado, 
                        LYcaCobrado,
                        LYanalisisGastos_d,
                        LYspots_d,

                ] = await Promise.all([
                        responseFacturado, 
                        responseCobrado, 
                        resAnalisisGastos,
                        resSpots,
                        LYresponseFacturado, 
                        LYresponseCobrado, 
                        LYresAnalisisGastos,
                        LYresSpots,
                ]);
                
                console.log('=========================');
                console.log('   AÑO ACTUAL: ' + year);
                console.log('=========================');
                console.log('selectedTax===');
                console.log(this.selectedTax);
                console.log('selectedTax===');
                var analisisGastos = analisisGastos_d.data.month;
                
                var spots = [];
                for (let spot_inx = 0; spot_inx < 12; spot_inx++) {
                    spots[spot_inx] = spots_d.data[spot_inx]?.client_rows?.[0]?.produced ?? 0;
                }
                var LYanalisisGastos = LYanalisisGastos_d.data.month;
                var LYspots = [];
                for (let LYspot_inx = 0; LYspot_inx < 12; LYspot_inx++) {
                    LYspots[LYspot_inx] = LYspots_d.data[LYspot_inx]?.client_rows?.[0]?.produced ?? 0;
                }

                var   obj_facturado = []; 
                            obj_facturado[0] = []; //IGUALAS
                            obj_facturado[1] = []; //IGUALAS
                            obj_facturado[2] = []; // SERV. ADICIONALES
                            obj_facturado[3] = []; // TOTAL
                            obj_facturado[4] = []; // separador ----------------
                            obj_facturado[5] = []; // COBRANZA IGUALAS
                            obj_facturado[6] = []; // COBRANZA SERV. ADICIONALES
                            obj_facturado[7] = []; // COBRANZA TOTAL
                            obj_facturado[8] = []; // Eficiencia de cobranza %
                            obj_facturado[9] = []; // GASTOS separador ----------------
                            obj_facturado[10] = []; // ADMINISTRACIÓN
                            obj_facturado[11] = []; // COMERCIAL
                            obj_facturado[12] = []; // OPERACIONES
                            obj_facturado[13] = []; // EXTRAORDINARIO 
                            obj_facturado[14] = []; // Gastos TOTALES
                            obj_facturado[15] = []; // UTILIDAD Real
                            obj_facturado[16] = []; // Utilidad Meta
                            obj_facturado[17] = []; // Utilidad Faltante
                            obj_facturado[18] = []; // separadorx ----------------
                            obj_facturado[19] = []; // Utilidad en Flujo de Efectivo
                            obj_facturado[20] = []; // separador ----------------
                            obj_facturado[21] = []; // SPOTS POR MES
                            obj_facturado[22] = []; // Costo por spot
                            obj_facturado[23] = []; // separador ----------------

                const   LYobj_facturado = []; 
                            LYobj_facturado[0] = []; //IGUALAS
                            LYobj_facturado[1] = []; //IGUALAS
                            LYobj_facturado[2] = []; // SERV. ADICIONALES
                            LYobj_facturado[3] = []; // TOTAL
                            LYobj_facturado[4] = []; // separador ----------------
                            LYobj_facturado[5] = []; // COBRANZA IGUALAS
                            LYobj_facturado[6] = []; // COBRANZA SERV. ADICIONALES
                            LYobj_facturado[7] = []; // COBRANZA TOTAL
                            LYobj_facturado[8] = []; // Eficiencia de cobranza %
                            LYobj_facturado[9] = []; // GASTOS separador ----------------
                            LYobj_facturado[10] = []; // ADMINISTRACIÓN
                            LYobj_facturado[11] = []; // COMERCIAL
                            LYobj_facturado[12] = []; // OPERACIONES
                            LYobj_facturado[13] = []; // EXTRAORDINARIO 
                            LYobj_facturado[14] = []; // Gastos TOTALES
                            LYobj_facturado[15] = []; // UTILIDAD Real
                            LYobj_facturado[16] = []; // Utilidad Meta
                            LYobj_facturado[17] = []; // Utilidad Faltante
                            LYobj_facturado[18] = []; // separador ----------------
                            LYobj_facturado[19] = []; // Utilidad en Flujo de Efectivo
                            LYobj_facturado[20] = []; // separador ----------------
                            LYobj_facturado[21] = []; // SPOTS POR MES
                            LYobj_facturado[22] = []; // Costo por spot
                            LYobj_facturado[23] = []; // separador ----------------

                            //=====  FACTURADO  =====
                            if (caFacturado) {
                                obj_facturado[0][13] = 'FACTURACION';
                                LYobj_facturado[0][13] = 'FACTURACION';
                                //:::  IGUALAS  ::: 
                                        obj_facturado[1][12] = 0; //total
                                        obj_facturado[1][13] = 'IGUALAS';
                                        caFacturado.data.data['1'].data.totals.months.forEach((element, index) => {
                                            obj_facturado[1][index] = element?element:0;
                                            var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[1][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        obj_facturado[1][12] = (obj_facturado[1][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[1][12] = 0; //total
                                        LYobj_facturado[1][13] = 'IGUALAS';
                                        LYcaFacturado.data.data['1'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[1][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[1][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        LYobj_facturado[1][12] = (LYobj_facturado[1][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                //:::  IGUALAS  ::: 
                                //:::  SERV. ADICIONALES  ::: 
                                        obj_facturado[2][12] = 0; //total
                                        obj_facturado[2][13] = 'SERV. ADICIONALES';
                                        caFacturado.data.data['2'].data.totals.months.forEach((element, index) => {
                                                obj_facturado[2][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[2][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        obj_facturado[2][12] = (obj_facturado[2][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                        LYobj_facturado[2][12] = 0; //total
                                        LYobj_facturado[2][13] = 'SERV. ADICIONALES';
                                        LYcaFacturado.data.data['2'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[2][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[2][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        LYobj_facturado[2][12] = (LYobj_facturado[2][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                //:::  SERV. ADICIONALES  ::: 
                                //:::  TOTAL  ::: 
                                        obj_facturado[3][12] = 0; //total
                                        obj_facturado[3][13] = 'TOTAL';
                                        caFacturado.data.data['3'].data.totals.months.forEach((element, index) => {
                                                obj_facturado[3][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[3][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        obj_facturado[3][12] = (obj_facturado[3][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[3][12] = 0; //total
                                        LYobj_facturado[3][13] = 'TOTAL';
                                        LYcaFacturado.data.data['3'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[3][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[3][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        LYobj_facturado[3][12] = (LYobj_facturado[3][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                //:::  TOTAL  ::: 
                            }
                            //=====  FACTURADO  =====
                            //=====  COBRANZA   =====
                            if  (caCobrado) {
                                obj_facturado[4][13] = 'COBRANZA';
                                LYobj_facturado[4][13] = 'COBRANZA';
                                //:::  IGUALAS  ::: 
                                        obj_facturado[5][12] = 0; //total
                                        obj_facturado[5][13] = 'IGUALAS';
                                        caCobrado.data.data['1'].data.totals.months.forEach((element, index) => {
                                                obj_facturado[5][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[5][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        obj_facturado[5][12] = (obj_facturado[5][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[5][12] = 0; //total
                                        LYobj_facturado[5][13] = 'IGUALAS';
                                        LYcaCobrado.data.data['1'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[5][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[5][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        LYobj_facturado[5][12] = (LYobj_facturado[5][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                //:::  IGUALAS  ::: 
                                //:::  SERV. ADICIONALES  ::: 
                                        obj_facturado[6][12] = 0; //total
                                        obj_facturado[6][13] = 'SERV. ADICIONALES';
                                        caCobrado.data.data['2'].data.totals.months.forEach((element, index) => {
                                                obj_facturado[6][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[6][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        obj_facturado[6][12] = (obj_facturado[6][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[6][12] = 0; //total
                                        LYobj_facturado[6][13] = 'SERV. ADICIONALES';
                                        LYcaCobrado.data.data['2'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[6][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[6][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        }); 
                                        LYobj_facturado[6][12] = (LYobj_facturado[6][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                //:::  SERV. ADICIONALES  ::: 
                                //:::  TOTAL  ::: 
                                        obj_facturado[7][12] = 0; //total
                                        obj_facturado[7][13] = 'TOTAL';
                                        caCobrado.data.data['3'].data.totals.months.forEach((element, index) => {
                                                obj_facturado[7][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                obj_facturado[7][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        obj_facturado[7][12] = (obj_facturado[7][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[7][12] = 0; //total
                                        LYobj_facturado[7][13] = 'TOTAL';
                                        LYcaCobrado.data.data['3'].data.totals.months.forEach((element, index) => {
                                                LYobj_facturado[7][index] = element?element:0;
                                                var element_aux = typeof element === 'string' ? element.replace(/,/g, "") : element;
                                                LYobj_facturado[7][12] += parseFloat(element_aux)?parseFloat(element_aux):0;
                                        });
                                        LYobj_facturado[7][12] = (LYobj_facturado[7][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                //:::  TOTAL  :::
                            }
                            if  (caFacturado && caCobrado) {
                                //:::  Eficiencia de cobranza %  ::: 
                                        obj_facturado[8][13] = 'Eficiencia de cobranza %';
                                        obj_facturado[3].forEach((element, index) => {
                                        if (index!=13) {
                                                var totalFacturado = typeof obj_facturado[3][index] === 'string' ? obj_facturado[3][index].replace(/,/g, "") : obj_facturado[3][index];
                                                var totalCobrado = typeof obj_facturado[7][index] === 'string' ? obj_facturado[7][index].replace(/,/g, "") : obj_facturado[7][index];
                                                var aux = (parseFloat(totalCobrado)/parseFloat(totalFacturado));
                                                if (totalCobrado != 0 && totalFacturado != 0) {
                                                        aux = aux.toFixed(2);
                                                }
                                                obj_facturado[8][index] = aux?aux:0;
                                        }
                                        });
                                        
                                        LYobj_facturado[8][13] = 'Eficiencia de cobranza %';
                                        LYobj_facturado[3].forEach((element, index) => {
                                        if (index!=13) {
                                            var totalFacturado = typeof LYobj_facturado[3][index] === 'string' ? LYobj_facturado[3][index].replace(/,/g, "") : LYobj_facturado[3][index];
                                            var totalCobrado = typeof LYobj_facturado[7][index] === 'string' ? LYobj_facturado[7][index].replace(/,/g, "") : LYobj_facturado[7][index];
                                            var aux = (parseFloat(totalCobrado)/parseFloat(totalFacturado));
                                            //convert aux to numberformat 00.00
                                            if (totalCobrado != 0 && totalFacturado != 0) {
                                                aux = aux.toFixed(2);
                                            }
                                            LYobj_facturado[8][index] = aux?aux:0;
                                        }
                                        });
                                //:::  Eficiencia de cobranza %  :::
                                //:::  GASTOS  ::: 
                                        obj_facturado[9][13] = 'GASTOS';
                                        var lastNodeEne = [];
                                        
                                        obj_facturado[10][12] = 0; //total
                                        obj_facturado[11][12] = 0; //total
                                        obj_facturado[12][12] = 0; //total
                                        obj_facturado[13][12] = 0; //total
                                        obj_facturado[14][12] = 0; //total
                                        for (var i = 0; i < 12; i++) {
                                                lastNodeEne = analisisGastos[i].categories[Object.keys(analisisGastos[i].categories).pop()].data;
                                            obj_facturado[10][i] = lastNodeEne[0] ? lastNodeEne[0] : 0;
                                            obj_facturado[11][i] = lastNodeEne[1] ? lastNodeEne[1] : 0;
                                            obj_facturado[12][i] = lastNodeEne[2] ? lastNodeEne[2] : 0;
                                            obj_facturado[13][i] = lastNodeEne[3] ? lastNodeEne[3] : 0;
                                            obj_facturado[14][i] = lastNodeEne[4] ? lastNodeEne[4] : 0;

                                             
                                                obj_facturado[10][12] += parseFloat(this.getNumberNoFormat(obj_facturado[10][i]))?parseFloat(this.getNumberNoFormat(obj_facturado[10][i])):0;
                                                obj_facturado[11][12] += parseFloat(this.getNumberNoFormat(obj_facturado[11][i]))?parseFloat(this.getNumberNoFormat(obj_facturado[11][i])):0;
                                                obj_facturado[12][12] += parseFloat(this.getNumberNoFormat(obj_facturado[12][i]))?parseFloat(this.getNumberNoFormat(obj_facturado[12][i])):0;
                                                obj_facturado[13][12] += parseFloat(this.getNumberNoFormat(obj_facturado[13][i]))?parseFloat(this.getNumberNoFormat(obj_facturado[13][i])):0;
                                                obj_facturado[14][12] += parseFloat(this.getNumberNoFormat(obj_facturado[14][i]))?parseFloat(this.getNumberNoFormat(obj_facturado[14][i])):0;
                                        }
                                        obj_facturado[10][12] = (obj_facturado[10][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[11][12] = (obj_facturado[11][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[12][12] = (obj_facturado[12][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[13][12] = (obj_facturado[13][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[14][12] = (obj_facturado[14][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                        LYobj_facturado[9][13] = 'GASTOS';
                                        var LYlastNodeEne = [];

                                        LYobj_facturado[10][12] = 0; //total
                                        LYobj_facturado[11][12] = 0; //total
                                        LYobj_facturado[12][12] = 0; //total
                                        LYobj_facturado[13][12] = 0; //total
                                        LYobj_facturado[14][12] = 0; //total
                                        for (var LYi = 0; LYi < 12; LYi++) {
                                                LYlastNodeEne = LYanalisisGastos[LYi].categories[Object.keys(LYanalisisGastos[LYi].categories).pop()].data;
                                            LYobj_facturado[10][LYi] = LYlastNodeEne[0] ? LYlastNodeEne[0] : 0;
                                            LYobj_facturado[11][LYi] = LYlastNodeEne[1] ? LYlastNodeEne[1] : 0;
                                            LYobj_facturado[12][LYi] = LYlastNodeEne[2] ? LYlastNodeEne[2] : 0;
                                            LYobj_facturado[13][LYi] = LYlastNodeEne[3] ? LYlastNodeEne[3] : 0;
                                            LYobj_facturado[14][LYi] = LYlastNodeEne[4] ? LYlastNodeEne[4] : 0;

                                                 
                                                LYobj_facturado[10][12] += parseFloat(this.getNumberNoFormat(LYobj_facturado[10][LYi]))?parseFloat(this.getNumberNoFormat(LYobj_facturado[10][LYi])):0;
                                                LYobj_facturado[11][12] += parseFloat(this.getNumberNoFormat(LYobj_facturado[11][LYi]))?parseFloat(this.getNumberNoFormat(LYobj_facturado[11][LYi])):0;
                                                LYobj_facturado[12][12] += parseFloat(this.getNumberNoFormat(LYobj_facturado[12][LYi]))?parseFloat(this.getNumberNoFormat(LYobj_facturado[12][LYi])):0;
                                                LYobj_facturado[13][12] += parseFloat(this.getNumberNoFormat(LYobj_facturado[13][LYi]))?parseFloat(this.getNumberNoFormat(LYobj_facturado[13][LYi])):0;
                                                LYobj_facturado[14][12] += parseFloat(this.getNumberNoFormat(LYobj_facturado[14][LYi]))?parseFloat(this.getNumberNoFormat(LYobj_facturado[14][LYi])):0;
                                        }
                                        LYobj_facturado[10][12] = (LYobj_facturado[10][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        LYobj_facturado[11][12] = (LYobj_facturado[11][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        LYobj_facturado[12][12] = (LYobj_facturado[12][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        LYobj_facturado[13][12] = (LYobj_facturado[13][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        LYobj_facturado[14][12] = (LYobj_facturado[14][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                //:::  GASTOS  :::
                                //:::  ADMINISTRACIÓN  ::: 
                                        obj_facturado[10][13] = 'ADMINISTRACIÓN';
                                        LYobj_facturado[10][13] = 'ADMINISTRACIÓN';
                                //:::  ADMINISTRACIÓN  :::
                                //:::  COMERCIAL  ::: 
                                        obj_facturado[11][13] = 'COMERCIAL';
                                        LYobj_facturado[11][13] = 'COMERCIAL';
                                //:::  COMERCIAL  :::
                                //:::  ADMINISTRACIÓN  ::: 
                                        obj_facturado[12][13] = 'OPERACIONES';
                                        LYobj_facturado[12][13] = 'OPERACIONES';
                                //:::  ADMINISTRACIÓN  :::
                                //:::  Extraordinario  ::: 
                                        obj_facturado[13][13] = 'Extraordinario';
                                        LYobj_facturado[13][13] = 'Extraordinario';
                                //:::  Extraordinario  :::
                                //:::  Gastos TOTALES  ::: 
                                        obj_facturado[14][13] = 'Gastos TOTALES';
                                        LYobj_facturado[14][13] = 'Gastos TOTALES';
                                //:::  Gastos TOTALES  :::


                                //:::  UTILIDAD Real  :::
                                        obj_facturado[15][13] = 'UTILIDAD Real';
                                        for (var ur_inx = 0; ur_inx <= 12; ur_inx++) {
                                                var ur_index = ur_inx;
                                            var ur_totalCobrado    = typeof obj_facturado[7][ur_index] === 'string' ? obj_facturado[7][ur_index].replace(/,/g, "") : obj_facturado[7][ur_index];
                                            var ur_totalGastos     = typeof obj_facturado[14][ur_index] === 'string' ? obj_facturado[14][ur_index].replace(/,/g, "") : obj_facturado[14][ur_index];
                                            var ur_aux = (parseFloat(ur_totalCobrado)-parseFloat(ur_totalGastos));
                                            //convert aux to numberformat 00.00
                                            if (ur_totalCobrado != 0 && ur_totalGastos != 0) {
                                                ur_aux = ur_aux.toFixed(2);
                                            }
                                            obj_facturado[15][ur_index] = ur_aux?ur_aux:0;
                                            obj_facturado[15][ur_index] = obj_facturado[15][ur_index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        //mete el ciclo en comentarios anterior en un for en lugar de for each donde la variable del for se llame index
                                        LYobj_facturado[15][13] = 'UTILIDAD Real';
                                        for (var LYur_inx = 0; LYur_inx <= 12; LYur_inx++) {
                                                var LYur_index = LYur_inx;
                                            var LYur_totalCobrado    = typeof LYobj_facturado[7][LYur_index] === 'string' ? LYobj_facturado[7][LYur_index].replace(/,/g, "") : LYobj_facturado[7][LYur_index];
                                            var LYur_totalGastos     = typeof LYobj_facturado[14][LYur_index] === 'string' ? LYobj_facturado[14][LYur_index].replace(/,/g, "") : LYobj_facturado[14][LYur_index];
                                            var LYur_aux = (parseFloat(LYur_totalCobrado)-parseFloat(LYur_totalGastos));
                                            //convert aux to numberformat 00.00
                                            if (LYur_totalCobrado != 0 && LYur_totalGastos != 0) {
                                                LYur_aux = LYur_aux.toFixed(2);
                                            }
                                            LYobj_facturado[15][LYur_index] = LYur_aux?LYur_aux:0;
                                            LYobj_facturado[15][LYur_index] = LYobj_facturado[15][LYur_index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        
                //console.log('obj_facturado',obj_facturado);
                //console.log('LYobj_facturado',LYobj_facturado);
                                //:::  UTILIDAD Real  :::
                                //:::  Utilidad Meta  ::: 
                                        obj_facturado[16][13] = 'Utilidad Meta';
                                        obj_facturado[16][12] = 0; //total
                                        obj_facturado[17][12] = 0; //total
                                        
                                        if (this.metaUtilidadReal[year]) {

                                                this.metaUtilidadReal[year].forEach((element, index) => {
                                                        obj_facturado[16][index] = element?element:0;
                                                        obj_facturado[16][12] += parseFloat(element)?parseFloat(element):0;
                                                var utilidadReal = typeof obj_facturado[15][index] === 'string' ? obj_facturado[15][index].replace(/,/g, "") : obj_facturado[15][index];
                                                var utilidadFaltante = (parseFloat(element)-parseFloat(utilidadReal));
                                                        obj_facturado[17][index] = utilidadFaltante?utilidadFaltante:0;
                                                        obj_facturado[17][12] += parseFloat(utilidadFaltante)?parseFloat(utilidadFaltante):0;

                                                var totalCobrado = typeof obj_facturado[7][index] === 'string' ? obj_facturado[7][index].replace(/,/g, "") : obj_facturado[7][index];
                                                var utilidadFlujoEfectivo = (parseFloat(utilidadReal)/parseFloat(totalCobrado));
                                                        if (totalCobrado != 0 && utilidadReal != 0) {
                                                        utilidadFlujoEfectivo = utilidadFlujoEfectivo.toFixed(2);
                                                        }
                                                        obj_facturado[19][index] = utilidadFlujoEfectivo?utilidadFlujoEfectivo:0;
                                                        
                                                        obj_facturado[17][index] = (obj_facturado[17][index].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                
                                                });
                                        }else{
                                                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No existe la meta de Utilidad del año:'+year , life: 5000, group: 'topr' });
                                        }
                                        obj_facturado[16][12] = (obj_facturado[16][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[17][12] = (obj_facturado[17][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        
                                        LYobj_facturado[16][13] = 'Utilidad Meta';
                                        LYobj_facturado[16][12] = 0; //total
                                        LYobj_facturado[17][12] = 0; //total
                                        if (this.metaUtilidadReal[lastYear]) {
                                            this.metaUtilidadReal[lastYear].forEach((element, index) => {
                                                LYobj_facturado[16][index] = element?element:0;
                                                LYobj_facturado[16][12] += parseFloat(element)?parseFloat(element):0;

                                            var utilidadReal = typeof LYobj_facturado[15][index] === 'string' ? LYobj_facturado[15][index].replace(/,/g, "") : LYobj_facturado[15][index];
                                            var utilidadFaltante = (parseFloat(element)-parseFloat(utilidadReal));
                                                LYobj_facturado[17][index] = utilidadFaltante?utilidadFaltante:0;
                                                LYobj_facturado[17][12] += parseFloat(utilidadFaltante)?parseFloat(utilidadFaltante):0;
                                                

                                            var totalCobrado = typeof LYobj_facturado[7][index] === 'string' ? LYobj_facturado[7][index].replace(/,/g, "") : LYobj_facturado[7][index];
                                            var utilidadFlujoEfectivo = (parseFloat(utilidadReal)/parseFloat(totalCobrado));
                                                if (totalCobrado != 0 && utilidadReal != 0) {
                                                    utilidadFlujoEfectivo = utilidadFlujoEfectivo.toFixed(2);
                                                }
                                                LYobj_facturado[19][index] = utilidadFlujoEfectivo?utilidadFlujoEfectivo:0;

                                                LYobj_facturado[17][index] = (LYobj_facturado[17][index].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                            
                                        });
                                            LYobj_facturado[16][12] = (LYobj_facturado[16][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                            LYobj_facturado[17][12] = (LYobj_facturado[17][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                //:::  Utilidad Meta  :::
                                //:::  Utilidad Faltante  ::: 
                                        obj_facturado[17][13] = 'Utilidad Faltante';
                                        LYobj_facturado[17][13] = 'Utilidad Faltante';
                                //:::  Utilidad Faltante  :::
                                //:::  separador ----------------  ::: 
                                        obj_facturado[18][13] = '';//Separador ----------------
                                        LYobj_facturado[18][13] = '';//Separador ----------------
                                //:::  separador ----------------  :::
                                //:::  Utilidad en Flujo de Efectivo  ::: 
                                        obj_facturado[19][13] = 'Utilidad en Flujo de Efectivo';
                                        LYobj_facturado[19][13] = 'Utilidad en Flujo de Efectivo';
                                //:::  Utilidad en Flujo de Efectivo  :::
                                //:::  Separador ----------------  ::: 
                                        obj_facturado[20][13] = '';//Separador ----------------
                                        LYobj_facturado[20][13] = '';//Separador ----------------
                                //:::  Separador ----------------  :::
                                //:::  SPOTS POR MES  ::: 
                                        obj_facturado[21][13] = 'SPOTS POR MES';
                                        obj_facturado[21][12] = 0; //total
                                        obj_facturado[22][12] = 0; //total
                                        spots.forEach((element, index) => {
                                            obj_facturado[21][index] = element?element:0;
                                            obj_facturado[21][12] += parseFloat(element)?parseFloat(element):0;
                                            var totalGastos     = typeof obj_facturado[14][index] === 'string' ? obj_facturado[14][index].replace(/,/g, "") : obj_facturado[14][index];
                                            var aux = (parseFloat(totalGastos)/element);
                                                if (totalGastos != 0 && element != 0) {
                                                    aux = aux.toFixed(2);
                                                }
                                                obj_facturado[22][index] = aux?aux:0;
                                                obj_facturado[22][12] += parseFloat(aux)?parseFloat(aux):0;
                                        });
                                        obj_facturado[21][12] = (obj_facturado[21][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        obj_facturado[22][12] = (obj_facturado[22][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                        LYobj_facturado[21][13] = 'SPOTS POR MES';
                                        LYobj_facturado[21][12] = 0; //total
                                        LYobj_facturado[22][12] = 0; //total
                                        LYspots.forEach((element, index) => {
                                                LYobj_facturado[21][index] = element?element:0;
                                                LYobj_facturado[21][12] += parseFloat(element)?parseFloat(element):0;
                                            var totalGastos     = typeof LYobj_facturado[14][index] === 'string' ? LYobj_facturado[14][index].replace(/,/g, "") : LYobj_facturado[14][index];
                                            var aux = (parseFloat(totalGastos)/element);
                                                //convert aux to numberformat 00.00
                                                if (totalGastos != 0 && element != 0) {
                                                    aux = aux.toFixed(2);
                                                }
                                                LYobj_facturado[22][index] = aux?aux:0;
                                                LYobj_facturado[22][12] += parseFloat(aux)?parseFloat(aux):0;
                                        });
                                        LYobj_facturado[21][12] = (LYobj_facturado[21][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        LYobj_facturado[22][12] = (LYobj_facturado[22][12].toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                //:::  SPOTS POR MES  :::
                                //:::  Costo por spot  ::: 
                                        obj_facturado[22][13] = 'Costo por spot';
                                        LYobj_facturado[22][13] = 'Costo por spot';
                                //:::  Costo por spot  :::
                                //:::  separador ----------------  ::: 
                                        obj_facturado[23][13] = '';//Separador ----------------
                                        LYobj_facturado[23][13] = '';//Separador ----------------
                                //:::  separador ----------------  :::

                            }
                            //=====  COBRANZA   =====

                            
                            
                        /*==================================================================
                                ASIGNACION DE DATOS A VARIABLES GLOBALES Y QUITAR EL IVA
                        ==================================================================*/

                                this.sdata_cIvaFacturado = obj_facturado;
                                this.sdata_sIvaFacturado = JSON.parse(JSON.stringify(this.sdata_cIvaFacturado));

                                var sIvaFacturado_indices = [1, 2, 3, 5, 6, 7, 10, 11, 12, 13, 14, 15, 17, 22 ];

                                for (var i_di = 0; i_di < sIvaFacturado_indices.length; i_di++) {
                                        for (var j_inx = 0; j_inx <= 12; j_inx++) {
                                                var value = this.getNumberNoFormat(this.sdata_cIvaFacturado[sIvaFacturado_indices[i_di]][j_inx]);
                                                value = (value / 1.16);
                                                value = this.getNumberFormat(value);
                                                this.sdata_sIvaFacturado[sIvaFacturado_indices[i_di]][j_inx] = value;
                                        }
                                }
                            
                                console.log('CON IVA   ::::::::::::::::::::::::::');
                                console.log(this.sdata_cIvaFacturado);
                                console.log('CON IVA   ::::::::::::::::::::::::::');
                                
                                console.log('SIN IVA   ::::::::::::::::::::::::::');
                                console.log(this.sdata_sIvaFacturado);
                                console.log('SIN IVA   ::::::::::::::::::::::::::');

                        // DATOS DEL AÑO ANTERIOR

                                this.sdata_cIvaLYFacturado = LYobj_facturado;
                                this.sdata_sIvaLYFacturado = JSON.parse(JSON.stringify(this.sdata_cIvaLYFacturado));

                                var sIvaLYFacturado_indices = [1, 2, 3, 5, 6, 7, 10, 11, 12, 13, 14, 15, 17, 22 ];

                                for (var i_diLY = 0; i_diLY < sIvaLYFacturado_indices.length; i_diLY++) {
                                        for (var j_inxLY = 0; j_inxLY <= 12; j_inxLY++) {
                                                var valueLY = this.getNumberNoFormat(this.sdata_cIvaLYFacturado[sIvaLYFacturado_indices[i_diLY]][j_inxLY]);
                                                valueLY = (valueLY / 1.16);
                                                valueLY = this.getNumberFormat(valueLY);
                                                this.sdata_sIvaLYFacturado[sIvaLYFacturado_indices[i_diLY]][j_inxLY] = valueLY;
                                        }
                                }
                            
                                console.log('CON IVA LY  ::::::::::::::::::::::::');
                                console.log(this.sdata_cIvaLYFacturado);
                                console.log('CON IVA LY  ::::::::::::::::::::::::');
                                
                                console.log('SIN IVA LY  ::::::::::::::::::::::::');
                                console.log(this.sdata_sIvaLYFacturado);
                                console.log('SIN IVA LY  ::::::::::::::::::::::::');

                        /*==================================================================
                                ASIGNACION DE DATOS A VARIABLES GLOBALES Y QUITAR EL IVA
                        ==================================================================*/
                        if (this.selectedTax.code == 1){ // SIN IVA
                                this.t_facturado = this.sdata_sIvaFacturado;
                                this.setChartGeneralData(this.sdata_sIvaFacturado, this.sdata_sIvaLYFacturado, year, lastYear);
                        
                        }else{ // CON IVA
                                this.t_facturado = this.sdata_cIvaFacturado;
                                this.setChartGeneralData(this.sdata_cIvaFacturado, this.sdata_cIvaLYFacturado, year, lastYear);
                        }

                        /*
                                //=====  CHARTS GENERALES  =====
                                var data_items = [];
                                var data_items_indices = [3, 7, 14];

                                for (var i_di = 0; i_di < data_items_indices.length; i_di++) {
                                        var item = [];

                                        for (var j = 0; j < 12; j++) {
                                                var value = typeof obj_facturado[data_items_indices[i_di]][j] === 'string' ? obj_facturado[data_items_indices[i_di]][j].replace(/,/g, "") : obj_facturado[data_items_indices[i_di]][j];
                                                item.push(value);
                                        }

                                        data_items.push(item);
                                }

                                this.chartData = this.setChartData(data_items);
                                this.chartOptions = this.setChartOptions();

                                //=====  CHARTS GASTOS ANUALES  =====
                                var iArray = [10, 11, 12, 13];
                                var data_items_gastos_anuales = [];
                                var data_items_gastos_anuale_ly = [];

                                for (var i_ga = 0; i_ga < iArray.length; i_ga++) {
                                        var item_ga = [];
                                        var item_ga_ly = [];
                                        for (var j_ga = 0; j_ga < 12; j_ga++) {
                                                var value_ga = typeof obj_facturado[iArray[i_ga]][j_ga] === 'string' ? obj_facturado[iArray[i_ga]][j_ga].replace(/,/g, "") : obj_facturado[iArray[i_ga]][j_ga];
                                                item_ga.push(value_ga);
                                                var value_ga_ly = typeof LYobj_facturado[iArray[i_ga]][j_ga] === 'string' ? LYobj_facturado[iArray[i_ga]][j_ga].replace(/,/g, "") : LYobj_facturado[iArray[i_ga]][j_ga];
                                                item_ga_ly.push(value_ga_ly);
                                        }
                                        data_items_gastos_anuales.push(item_ga);
                                        data_items_gastos_anuale_ly.push(item_ga_ly);
                                }
                                this.chartData_gastos_anuales = this.setChartData_gastos_anuales(data_items_gastos_anuales, data_items_gastos_anuale_ly, lastYear, year);
                                this.chartOptions_gastos_anuales = this.setChartOptions_gastos_anuales();

                                //=====  CHARTS UTILIDADES   =====
                                var utilidadArray = [15, 16, 17];
                                var data_items_utilidad = [];
                                var item_ut_ly = [];
                                for (var i_ut = 0; i_ut < utilidadArray.length; i_ut++) {
                                        var item_ut = [];
                                        for (var j_ut = 0; j_ut < 12; j_ut++) {
                                                var value_ut = typeof obj_facturado[utilidadArray[i_ut]][j_ut] === 'string' ? obj_facturado[utilidadArray[i_ut]][j_ut].replace(/,/g, "") : obj_facturado[utilidadArray[i_ut]][j_ut];
                                                item_ut.push(value_ut);
                                                if (i_ut==0) {
                                                var value_ut_ly = typeof LYobj_facturado[utilidadArray[i_ut]][j_ut] === 'string' ? LYobj_facturado[utilidadArray[i_ut]][j_ut].replace(/,/g, "") : LYobj_facturado[utilidadArray[i_ut]][j_ut];
                                                        item_ut_ly.push(value_ut_ly);
                                                }
                                        }
                                        data_items_utilidad.push(item_ut);
                                }
                                data_items_utilidad.push(item_ut_ly);
                                this.chartData_utilidad = this.setChartData_utilidad(data_items_utilidad, lastYear, year);
                                this.chartOptions_utilidad = this.setChartOptions_utilidad();


                        */

                                console.log('t_Resultados_mes INICIANDO');
                    var   t_Resultados_mes = []; 
                for (let inx = 0; inx < 12; inx++) {
                        t_Resultados_mes = []; 
                            t_Resultados_mes[0] = []; //Facturación
                            t_Resultados_mes[1] = []; //IGUALAS
                            t_Resultados_mes[2] = []; // SERV. ADICIONALES
                            t_Resultados_mes[3] = []; // TOTAL
                            t_Resultados_mes[4] = []; // separador ----------------
                            t_Resultados_mes[5] = []; // COBRANZA IGUALAS
                            t_Resultados_mes[6] = []; // COBRANZA SERV. ADICIONALES
                            t_Resultados_mes[7] = []; // COBRANZA TOTAL
                            t_Resultados_mes[8] = []; // Eficiencia de cobranza %
                            t_Resultados_mes[9] = []; // GASTOS separador ----------------
                            t_Resultados_mes[10] = []; // ADMINISTRACIÓN
                            t_Resultados_mes[11] = []; // COMERCIAL
                            t_Resultados_mes[12] = []; // OPERACIONES
                            t_Resultados_mes[13] = []; // EXTRAORDINARIO
                            t_Resultados_mes[14] = []; // Gastos TOTALES
                            t_Resultados_mes[15] = []; // UTILIDAD Real
                            t_Resultados_mes[16] = []; // separador ----------------
                            t_Resultados_mes[17] = []; // Utilidad en Flujo de Efectivo
                            t_Resultados_mes[18] = []; // separador ----------------
                            t_Resultados_mes[19] = []; // SPOTS POR MES
                            t_Resultados_mes[20] = []; // Costo por spot
                            t_Resultados_mes[21] = []; // separador ----------------
                            console.log('t_Resultados_mes: ' + inx);
                            t_Resultados_mes[0][13] = 'FACTURACION';t_Resultados_mes[0][0] = 'FACTURACION';
                                //:::  IGUALAS  ::: 
                                t_Resultados_mes[1][13] = 'IGUALAS';
                                                t_Resultados_mes[1]['real'] = obj_facturado[1][inx];
                                                t_Resultados_mes[1]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[1][inx]);
                                                t_Resultados_mes[1]['eficiencia'] = this.getEficiencia(t_Resultados_mes[1]['real'], t_Resultados_mes[1]['meta']);
                                                t_Resultados_mes[1]['byReal'] = LYobj_facturado[1][inx];
                                                t_Resultados_mes[1]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[1]['real'], t_Resultados_mes[1]['byReal']);
                                //:::  IGUALAS  ::: 
                                //:::  SERV. ADICIONALES  ::: 
                                t_Resultados_mes[2][13] = 'SERV. ADICIONALES';
                                                t_Resultados_mes[2]['real'] = obj_facturado[2][inx];
                                                t_Resultados_mes[2]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[2][inx]);
                                                t_Resultados_mes[2]['eficiencia'] = this.getEficiencia(t_Resultados_mes[2]['real'], t_Resultados_mes[2]['meta']);
                                                t_Resultados_mes[2]['byReal'] = LYobj_facturado[2][inx];
                                                t_Resultados_mes[2]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[2]['real'], t_Resultados_mes[2]['byReal']);
                                //:::  SERV. ADICIONALES  ::: 
                                //:::  TOTAL  ::: 
                                t_Resultados_mes[3][13] = 'TOTAL';
                                                t_Resultados_mes[3]['real'] = obj_facturado[3][inx];
                                                t_Resultados_mes[3]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[3][inx]);
                                                t_Resultados_mes[3]['eficiencia'] = this.getEficiencia(t_Resultados_mes[3]['real'], t_Resultados_mes[3]['meta']);
                                                t_Resultados_mes[3]['byReal'] = LYobj_facturado[3][inx];
                                                t_Resultados_mes[3]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[3]['real'], t_Resultados_mes[3]['byReal']);
                                //:::  TOTAL  ::: 
                                //:::  COBRANZA ----------------  :::
                                t_Resultados_mes[4][13] = 'COBRANZA';//COBRANZA
                                //:::  COBRANZA ----------------  :::
                                t_Resultados_mes[5][13] = 'IGUALAS';
                                                t_Resultados_mes[5]['real'] = obj_facturado[5][inx];
                                                t_Resultados_mes[5]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[5][inx]);
                                                t_Resultados_mes[5]['eficiencia'] = this.getEficiencia(t_Resultados_mes[5]['real'], t_Resultados_mes[5]['meta']);
                                                t_Resultados_mes[5]['byReal'] = LYobj_facturado[5][inx];
                                                t_Resultados_mes[5]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[5]['real'], t_Resultados_mes[5]['byReal']);
                                //:::  IGUALAS  ::: 
                                //:::  SERV. ADICIONALES  ::: 
                                t_Resultados_mes[6][13] = 'SERV. ADICIONALES';
                                                t_Resultados_mes[6]['real'] = obj_facturado[6][inx];
                                                t_Resultados_mes[6]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[6][inx]);
                                                t_Resultados_mes[6]['eficiencia'] = this.getEficiencia(t_Resultados_mes[6]['real'], t_Resultados_mes[6]['meta']);
                                                t_Resultados_mes[6]['byReal'] = LYobj_facturado[6][inx];
                                                t_Resultados_mes[6]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[6]['real'], t_Resultados_mes[6]['byReal']);
                                //:::  SERV. ADICIONALES  ::: 
                                //:::  TOTAL  ::: 
                                t_Resultados_mes[7][13] = 'TOTAL';
                                                t_Resultados_mes[7]['real'] = obj_facturado[7][inx];
                                                t_Resultados_mes[7]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[7][inx]);
                                                t_Resultados_mes[7]['eficiencia'] = this.getEficiencia(t_Resultados_mes[7]['real'], t_Resultados_mes[7]['meta']);
                                                t_Resultados_mes[7]['byReal'] = LYobj_facturado[7][inx];
                                                t_Resultados_mes[7]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[7]['real'], t_Resultados_mes[7]['byReal']);
                                //:::  TOTAL  ::: 
                                //:::  Eficiencia de cobranza %  :::
                                t_Resultados_mes[8][13] = 'Eficiencia de cobranza %';
                                                t_Resultados_mes[8]['real'] = obj_facturado[8][inx];
                                                t_Resultados_mes[8]['meta'] = '';
                                                t_Resultados_mes[8]['eficiencia'] = '';
                                                t_Resultados_mes[8]['byReal'] = LYobj_facturado[8][inx];
                                                t_Resultados_mes[8]['byEficiencia'] = '';
                                //:::  Eficiencia de cobranza %  :::
                                //:::  GASTOS ----------------  :::
                                t_Resultados_mes[9][13] = 'GASTOS';//GASTOS
                                //:::  GASTOS ----------------  :::
                                //:::  ADMINISTRACIÓN  :::
                                t_Resultados_mes[10][13] = 'ADMINISTRACIÓN';
                                                t_Resultados_mes[10]['real'] = obj_facturado[10][inx];
                                                t_Resultados_mes[10]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[10][inx]);
                                                t_Resultados_mes[10]['eficiencia'] = this.getEficiencia(t_Resultados_mes[10]['real'], t_Resultados_mes[10]['meta']);
                                                t_Resultados_mes[10]['byReal'] = LYobj_facturado[10][inx];
                                                t_Resultados_mes[10]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[10]['real'], t_Resultados_mes[10]['byReal']);
                                //:::  ADMINISTRACIÓN  :::
                                //:::  COMERCIAL  :::
                                t_Resultados_mes[11][13] = 'COMERCIAL';
                                                t_Resultados_mes[11]['real'] = obj_facturado[11][inx];
                                                t_Resultados_mes[11]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[11][inx]);
                                                t_Resultados_mes[11]['eficiencia'] = this.getEficiencia(t_Resultados_mes[11]['real'], t_Resultados_mes[11]['meta']);
                                                t_Resultados_mes[11]['byReal'] = LYobj_facturado[11][inx];
                                                t_Resultados_mes[11]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[11]['real'], t_Resultados_mes[11]['byReal']);
                                //:::  COMERCIAL  :::
                                //:::  OPERACIONES  :::
                                t_Resultados_mes[12][13] = 'OPERACIONES';
                                                t_Resultados_mes[12]['real'] = obj_facturado[12][inx];
                                                t_Resultados_mes[12]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[12][inx]);
                                                t_Resultados_mes[12]['eficiencia'] = this.getEficiencia(t_Resultados_mes[12]['real'], t_Resultados_mes[12]['meta']);
                                                t_Resultados_mes[12]['byReal'] = LYobj_facturado[12][inx];
                                                t_Resultados_mes[12]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[12]['real'], t_Resultados_mes[12]['byReal']);
                                //:::  OPERACIONES  :::
                                //:::  EXTRAORDINARIO  :::
                                t_Resultados_mes[13][13] = 'EXTRAORDINARIO';
                                                t_Resultados_mes[13]['real'] = obj_facturado[13][inx];
                                                t_Resultados_mes[13]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[13][inx]);
                                                t_Resultados_mes[13]['eficiencia'] = this.getEficiencia(t_Resultados_mes[13]['real'], t_Resultados_mes[13]['meta']);
                                                t_Resultados_mes[13]['byReal'] = LYobj_facturado[13][inx];
                                                t_Resultados_mes[13]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[13]['real'], t_Resultados_mes[13]['byReal']);
                                //:::  EXTRAORDINARIO  :::
                                //:::  Gastos TOTALES  :::
                                t_Resultados_mes[14][13] = 'Gastos TOTALES';
                                                t_Resultados_mes[14]['real'] = obj_facturado[14][inx];
                                                t_Resultados_mes[14]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[14][inx]);
                                                t_Resultados_mes[14]['eficiencia'] = this.getEficiencia(t_Resultados_mes[14]['real'], t_Resultados_mes[14]['meta']);
                                                t_Resultados_mes[14]['byReal'] = LYobj_facturado[14][inx];
                                                t_Resultados_mes[14]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[14]['real'], t_Resultados_mes[14]['byReal']);
                                //:::  Gastos TOTALES  :::
                                //:::  UTILIDAD Real  :::
                                t_Resultados_mes[15][13] = 'UTILIDAD Real';
                                                t_Resultados_mes[15]['real'] = obj_facturado[15][inx];
                                                t_Resultados_mes[15]['meta'] = this.getMeta(this.valorCrecimiento[year], LYobj_facturado[15][inx]);
                                                t_Resultados_mes[15]['eficiencia'] = this.getEficiencia(t_Resultados_mes[15]['real'], t_Resultados_mes[15]['meta']);
                                                t_Resultados_mes[15]['byReal'] = LYobj_facturado[15][inx];
                                                t_Resultados_mes[15]['byEficiencia'] = this.getEficiencia(t_Resultados_mes[15]['real'], t_Resultados_mes[15]['byReal']);
                                //:::  UTILIDAD Real  :::
                                //:::  separador ----------------  :::
                                t_Resultados_mes[16][13] = '';
                                //:::  separador ----------------  :::
                                //:::  Utilidad en Flujo de Efectivo  :::
                                t_Resultados_mes[17][13] = 'Utilidad en Flujo de Efectivo';
                                                t_Resultados_mes[17]['real'] = obj_facturado[19][inx];
                                                t_Resultados_mes[17]['meta'] = '';
                                                t_Resultados_mes[17]['eficiencia'] = '';
                                                t_Resultados_mes[17]['byReal'] = LYobj_facturado[19][inx];
                                                t_Resultados_mes[17]['byEficiencia'] = '';
                                //:::  Utilidad en Flujo de Efectivo  :::
                                //:::  separador ----------------  :::
                                t_Resultados_mes[18][13] = '';
                                //:::  separador ----------------  :::
                                //:::  SPOTS POR MES  :::
                                t_Resultados_mes[19][13] = 'SPOTS POR MES';
                                                t_Resultados_mes[19]['real'] = obj_facturado[21][inx];
                                                t_Resultados_mes[19]['meta'] = '';
                                                t_Resultados_mes[19]['eficiencia'] = '';
                                                t_Resultados_mes[19]['byReal'] = LYobj_facturado[21][inx];
                                                t_Resultados_mes[19]['byEficiencia'] = '';
                                //:::  SPOTS POR MES  :::
                                //:::  Costo por spot  :::
                                t_Resultados_mes[20][13] = 'Costo por spot';
                                                t_Resultados_mes[20]['real'] = obj_facturado[22][inx];
                                                t_Resultados_mes[20]['meta'] = '';
                                                t_Resultados_mes[20]['eficiencia'] = '';
                                                t_Resultados_mes[20]['byReal'] = LYobj_facturado[22][inx];
                                                t_Resultados_mes[20]['byEficiencia'] = '';
                                //:::  Costo por spot  :::
                                //:::  separador ----------------  :::
                                t_Resultados_mes[21][13] = '';
                                //:::  separador ----------------  ::: 
                        
                                //console.log('t_Resultados_mes',t_Resultados_mes);

                                var t_Resultados_gastos_pie = [];
                                        t_Resultados_gastos_pie['administracion'] = t_Resultados_mes[10]['real'];
                                        t_Resultados_gastos_pie['comercial'] = t_Resultados_mes[11]['real'];
                                        t_Resultados_gastos_pie['operaciones'] = t_Resultados_mes[12]['real'];
                                        t_Resultados_gastos_pie['extraordinario'] = t_Resultados_mes[13]['real'];
                        
                                switch (inx) {
                                        case 0:
                                                this.t_Resultados_enero = t_Resultados_mes;
                                                this.t_Gastos_enero = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 1:
                                                this.t_Resultados_febrero = t_Resultados_mes;
                                                this.t_Gastos_febrero = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 2:
                                                this.t_Resultados_marzo = t_Resultados_mes;
                                                this.t_Gastos_marzo = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 3:
                                                this.t_Resultados_abril = t_Resultados_mes;
                                                this.t_Gastos_abril = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 4:
                                                this.t_Resultados_mayo = t_Resultados_mes;
                                                this.t_Gastos_mayo = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 5:
                                                this.t_Resultados_junio = t_Resultados_mes;
                                                this.t_Gastos_junio = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 6:
                                                this.t_Resultados_julio = t_Resultados_mes;
                                                this.t_Gastos_julio = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 7:
                                                this.t_Resultados_agosto = t_Resultados_mes;
                                                this.t_Gastos_agosto = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 8:
                                                this.t_Resultados_septiembre = t_Resultados_mes;
                                                this.t_Gastos_septiembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 9:
                                                this.t_Resultados_octubre = t_Resultados_mes;
                                                this.t_Gastos_octubre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 10:
                                                this.t_Resultados_noviembre = t_Resultados_mes;
                                                this.t_Gastos_noviembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                        case 11:
                                                this.t_Resultados_diciembre = t_Resultados_mes;
                                                this.t_Gastos_diciembre = this.setChartDataT_gastos_mes(t_Resultados_gastos_pie);
                                        break;
                                }
                }

                var t_Resultados_total_coniva = [];
                var t_Resultados_total_siniva = [];

                var meses = [
                "enero", "febrero", "marzo", "abril", "mayo", "junio",
                "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
                ];

                for (let inx = 0; inx < 12; inx++) {
                        const mes = this[`t_Resultados_${meses[inx]}`];
                        const mesSinIVA = mes.map(element => ({ ...element })); // Crear una copia profunda

                        for (let index = 0; index < mesSinIVA.length; index++) {
                                if (index == 0 || index == 4 || index == 8 || index == 9 || index == 16 || index == 17 || index == 18 || index == 19 || index == 21) {
                                // No se modifica nada aquí
                                } else {
                                const element = mesSinIVA[index];
                                element['real'] = this.getNumberFormat(this.getNumberNoFormat(element['real']) / 1.16);
                                if (index != 20){
                                        element['meta'] = this.getNumberFormat(this.getNumberNoFormat(element['meta']) / 1.16);
                                }
                                element['byReal'] = this.getNumberFormat(this.getNumberNoFormat(element['byReal']) / 1.16);
                                }
                        }

                        t_Resultados_total_coniva.push(mes);
                        t_Resultados_total_siniva.push(mesSinIVA);
                }

                console.log("t_Resultados_total_coniva");
                console.log(t_Resultados_total_coniva);
                console.log("t_Resultados_total_siniva");
                console.log(t_Resultados_total_siniva);
                 
                                this.sdata_cIvaResultadosMes = t_Resultados_total_coniva;
                                this.sdata_sIvaResultadosMes = t_Resultados_total_siniva;
  
                        } catch (error) {
                console.error("getYearToDay error:", error?.message || error, error?.response?.data || '');
                var detail = 'Error al cargar los datos. Intente de nuevo.';
                if (error?.response?.data?.message) {
                    detail = error.response.data.message;
                } else if (error?.message) {
                    detail = error.message;
                }
                this.$toast.add({ severity: 'error', summary: 'Error', detail: detail, life: 12000, group: 'topr' });
            }
 

            
            this.$emit('update-loading', false);

        },
        setChartGeneralData(obj_facturado, LYobj_facturado,year,lastYear){
                
                        console.log('setChartGeneralData');
                        console.log(obj_facturado);
                        console.log(LYobj_facturado);
                        console.log(year);
                        console.log(lastYear);
                try {

                        //=====  CHARTS GENERALES  =====
                        var data_items = [];
                                var data_items_indices = [3, 7, 14];

                                for (var i_di = 0; i_di < data_items_indices.length; i_di++) {
                                        var item = [];

                                        for (var j = 0; j < 12; j++) {
                                                var value = typeof obj_facturado[data_items_indices[i_di]][j] === 'string' ? obj_facturado[data_items_indices[i_di]][j].replace(/,/g, "") : obj_facturado[data_items_indices[i_di]][j];
                                                item.push(value);
                                        }

                                        data_items.push(item);
                                }

                                this.chartData = this.setChartData(data_items);
                                this.chartOptions = this.setChartOptions();

                                //=====  CHARTS GASTOS ANUALES  =====
                                var iArray = [10, 11, 12, 13];
                                var data_items_gastos_anuales = [];
                                var data_items_gastos_anuale_ly = [];

                                for (var i_ga = 0; i_ga < iArray.length; i_ga++) {
                                        var item_ga = [];
                                        var item_ga_ly = [];
                                        for (var j_ga = 0; j_ga < 12; j_ga++) {
                                                var value_ga = typeof obj_facturado[iArray[i_ga]][j_ga] === 'string' ? obj_facturado[iArray[i_ga]][j_ga].replace(/,/g, "") : obj_facturado[iArray[i_ga]][j_ga];
                                                item_ga.push(value_ga);
                                                var value_ga_ly = typeof LYobj_facturado[iArray[i_ga]][j_ga] === 'string' ? LYobj_facturado[iArray[i_ga]][j_ga].replace(/,/g, "") : LYobj_facturado[iArray[i_ga]][j_ga];
                                                item_ga_ly.push(value_ga_ly);
                                        }
                                        data_items_gastos_anuales.push(item_ga);
                                        data_items_gastos_anuale_ly.push(item_ga_ly);
                                }
                                this.chartData_gastos_anuales = this.setChartData_gastos_anuales(data_items_gastos_anuales, data_items_gastos_anuale_ly, lastYear, year);
                                this.chartOptions_gastos_anuales = this.setChartOptions_gastos_anuales();

                                //=====  CHARTS UTILIDADES   =====
                                var utilidadArray = [15, 16, 17];
                                var data_items_utilidad = [];
                                var item_ut_ly = [];
                                for (var i_ut = 0; i_ut < utilidadArray.length; i_ut++) {
                                        var item_ut = [];
                                        for (var j_ut = 0; j_ut < 12; j_ut++) {
                                                var value_ut = typeof obj_facturado[utilidadArray[i_ut]][j_ut] === 'string' ? obj_facturado[utilidadArray[i_ut]][j_ut].replace(/,/g, "") : obj_facturado[utilidadArray[i_ut]][j_ut];
                                                item_ut.push(value_ut);
                                                if (i_ut==0) {
                                                var value_ut_ly = typeof LYobj_facturado[utilidadArray[i_ut]][j_ut] === 'string' ? LYobj_facturado[utilidadArray[i_ut]][j_ut].replace(/,/g, "") : LYobj_facturado[utilidadArray[i_ut]][j_ut];
                                                        item_ut_ly.push(value_ut_ly);
                                                }
                                        }
                                        data_items_utilidad.push(item_ut);
                                }
                                data_items_utilidad.push(item_ut_ly);
                                this.chartData_utilidad = this.setChartData_utilidad(data_items_utilidad, lastYear, year);
                                this.chartOptions_utilidad = this.setChartOptions_utilidad();
                
                } catch (error) {
                        console.error("setChartGeneralData: There was an error!", error);
                }
        }
    },
    async mounted() {

        this.selectedYear = this.yearlist[0];
        this.selectedTax = this.tax_select[0];
        var yearlist_aux = [];
        var currentYear = new Date().getFullYear();
        for (var i = currentYear; i >= 2018; i--) {
                yearlist_aux.push({ id: i });
        }

        this.yearlist = yearlist_aux;

        console.log('mounted Indicadores Administracion=====================');
        var success = await this.fetchInitialData();
        if (success) {
            this.getYearToDay(currentYear);
        }
        console.log('mounted Indicadores Administracion=====================');

        // --- MutationObserver para detectar cambios en modo claro/oscuro ---
        const updateChartsTheme = () => {
                // Solo actualiza si los datos ya están cargados
                if (this.chartData) this.chartOptions = this.setChartOptions();
                if (this.chartData_gastos_anuales) this.chartOptions_gastos_anuales = this.setChartOptions_gastos_anuales();
                if (this.chartData_utilidad) this.chartOptions_utilidad = this.setChartOptions_utilidad();
        };
        this._themeMutationObserver = new MutationObserver(() => {
                updateChartsTheme();
        });
        this._themeMutationObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    },
    beforeUnmount() {
        if (this._themeMutationObserver) {
                this._themeMutationObserver.disconnect();
                this._themeMutationObserver = null;
        }
    },
    created() {
        /*
        console.log('created Indicadores Administracion=====================');
        this.getYearToDay(2022);
        console.log('created Indicadores Administracion=====================');
        */
    },
}
</script>

<style>
/* Light/Dark wrappers for this page */
/* Tables headers align to Tags page style */
html:not(.dark) .dTable_ytd .p-datatable-wrapper table thead tr th,
html:not(.dark) .dTable_edr .p-datatable-wrapper table thead tr th {
        background-color: #f4f4f5 !important;
        color: #18181b !important;
}
html.dark .dTable_ytd .p-datatable-wrapper table thead tr th,
html.dark .dTable_edr .p-datatable-wrapper table thead tr th {
        background-color: #18181b !important;
        color: #f4f4f5 !important;
}
/*  YEAR TO DAY  ===============================================*/
.dTable_ytd .p-datatable-wrapper table {}
.dTable_ytd .p-datatable-wrapper table thead{}
.dTable_ytd .p-datatable-wrapper table thead tr {}
.dTable_ytd .p-datatable-wrapper table thead tr th {
        background-color: rgb(19, 19, 19);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table thead tr th.title_col{
        background-color: black;
}
.dTable_ytd .p-datatable-wrapper table tbody {}
.dTable_ytd .p-datatable-wrapper table tbody tr {}
.dTable_ytd .p-datatable-wrapper table tbody tr td {
        padding: 2px 6px;
        border-width: 1px 1px 1px 1px !important;
        font-size: 14px !important;
        text-align: right;
}
.dTable_ytd .p-datatable-wrapper table tbody tr td.title_col {
        background-color: rgb(19, 19, 19);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(4) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(8) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(9) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(15) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(19) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(21) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(24) td {
        background-color: black;
        color: white;
        font-weight: bold;
        padding-top: 5px;
        padding-bottom: 5px;
}
/*separadores*/
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(19) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(21) td,
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(24) td {
        border-width: 0px 0px 0px 0px !important;
}

.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(1) td {
        background-color: rgb(0, 43, 122);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(2) td:nth-child(1),
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(3) td:nth-child(1) {
        background-color: rgb(0, 43, 122);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(5) td {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(6) td:nth-child(1),
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(7) td:nth-child(1) {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(10) td {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(11) td:nth-child(1),
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(12) td:nth-child(1),
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(13) td:nth-child(1),
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(14) td:nth-child(1) {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(16) td {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(17) td {
        background-color: rgb(0, 43, 122);
        color: white;
        font-weight: bold;
}
.dTable_ytd .p-datatable-wrapper table tbody tr:nth-child(18) td {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
/*  YEAR TO DAY  ===============================================*/
/*  Edo. Resultados MENSUAL  ===================================*/

.dTable_edr .p-datatable-wrapper table {}
.dTable_edr .p-datatable-wrapper table thead{}
.dTable_edr .p-datatable-wrapper table thead tr {}
.dTable_edr .p-datatable-wrapper table thead tr th {
        background-color: rgb(19, 19, 19);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table thead tr th.title_col{
        background-color: black;
}
.dTable_edr .p-datatable-wrapper table tbody {}
.dTable_edr .p-datatable-wrapper table tbody tr {}
.dTable_edr .p-datatable-wrapper table tbody tr td {
        padding: 2px 6px;
        border-width: 1px 1px 1px 1px !important;
        font-size: 14px !important;
        text-align: right;
}
.dTable_edr .p-datatable-wrapper table tbody tr td.title_col {
        background-color: rgb(19, 19, 19);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(4) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(8) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(9) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(15) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(17) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(19) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(21) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(24) td {
        background-color: black;
        color: white;
        font-weight: bold;
        padding-top: 5px;
        padding-bottom: 5px;
}
/*separadores*/
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(19) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(21) td,
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(24) td {
        border-width: 0px 0px 0px 0px !important;
}

.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(1) td {
        background-color: rgb(0, 43, 122);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(2) td:nth-child(1),
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(3) td:nth-child(1) {
        background-color: rgb(0, 43, 122);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(5) td {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(6) td:nth-child(1),
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(7) td:nth-child(1) {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(10) td {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(11) td:nth-child(1),
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(12) td:nth-child(1),
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(13) td:nth-child(1),
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(14) td:nth-child(1) {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(16) td {
        background-color: rgb(0, 122, 65);
        color: white;
        font-weight: bold;
}
.dTable_edr .p-datatable-wrapper table tbody tr:nth-child(18) td {
        background-color: rgb(122, 49, 0);
        color: white;
        font-weight: bold;
}
/*  Edo. Resultados MENSUAL  ===================================*/

.donut_chart_g canvas {
        min-width: 300px !important;
        min-height: 300px !important;
        width: 300px !important;
        height: 300px !important;
}
.p-tabview .p-tabview-nav li{
        width: 100% !important;
        padding: 1px;
        text-overflow: ellipsis;
}
.p-tabview-nav{
        position: relative;
        text-align: center;
        display: flex;
}
</style>